var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-mask" }, [
    _c("div", { staticClass: "modal-wrapper" }, [
      _c("div", { staticClass: "modal_size md_size" }, [
        _c(
          "a",
          {
            staticClass: "ui_close",
            attrs: { href: "javascript:", type: "button" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_c("span", { staticClass: "sr_only" }, [_vm._v("popup close")])]
        ),
        _vm._v(" "),
        _c("dl", { staticClass: "modal_content" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("dd", [
            _c("ul", { staticClass: "template_list" }, [
              _c("li", [
                _c(
                  "p",
                  {
                    staticClass: "template_img",
                    on: {
                      click: function($event) {
                        return _vm.handleClick("SB")
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: "/static/images/pic_template_01.png",
                        alt: "template img"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("span", [_vm._v("Service Bulletion")])
              ]),
              _vm._v(" "),
              _c("li", [
                _c(
                  "p",
                  {
                    staticClass: "template_img",
                    on: {
                      click: function($event) {
                        return _vm.handleClick("CG")
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: "/static/images/pic_template_03.png",
                        alt: "template img"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("span", [_vm._v("Call Guide")])
              ]),
              _vm._v(" "),
              _c("li", [
                _c(
                  "p",
                  {
                    staticClass: "template_img",
                    on: {
                      click: function($event) {
                        return _vm.handleClick("BP")
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: "/static/images/pic_template_04.png",
                        alt: "template img"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("span", [_vm._v("Blank Page")])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("dd", { staticClass: "scroll_btm" }, [
            _c("div", { staticClass: "tooltip_wrap fl_right" }, [
              _c("em", { staticClass: "ico_info_lg" }, [
                _c("i", { staticClass: "tooltip fl_right" }, [
                  _vm._v(_vm._s(_vm.$t("MESSAGE.KNOWLEDGE.TEMPLATE.TOOLTIP")))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "sr_only" }, [_vm._v("info")])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dt", { staticClass: "ellipsis" }, [
      _c("i", [_vm._v("Template")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39172419", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39172419","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/knowledge/popup/KnowledgeTemplatePopup.vue
// module id = NBmE
// module chunks = 0